var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useCallback } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Typography } from '../typography';
import styles from './text-editor.module.css';
export const TextEditor = (_a) => {
    var { label, value, onChange, disabled, className } = _a, rest = __rest(_a, ["label", "value", "onChange", "disabled", "className"]);
    const quillRef = useRef(null);
    const handleColorChange = useCallback((color) => {
        var _a;
        const quill = (_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor();
        if (quill && color) {
            quill.format('color', color);
        }
    }, []);
    const handleValueChange = useCallback((value, _, source) => {
        if (source === 'user') {
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }
    }, [onChange]);
    const modules = {
        toolbar: {
            container: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ color: [] }],
                ['blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link'],
            ],
            handlers: {
                color: handleColorChange,
            },
        },
    };
    return (_jsxs("div", { className: className, children: [label && _jsx(Typography, { variant: "subtitle1", children: label }), _jsx(ReactQuill, Object.assign({ readOnly: disabled, className: styles.textEditor, "data-testid": "quill-editor", ref: quillRef, theme: "snow", value: value, onChange: handleValueChange, modules: modules, formats: [
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'blockquote',
                    'list',
                    'bullet',
                    'link',
                    'color',
                ] }, rest))] }));
};
